import { trackErrorPageRendered } from './src/acquisition/actions';
import { logInFailure } from './src/techstyle-shared/react-accounts';
import { createGoogleTagManagerEvents } from './src/techstyle-shared/react-marketing';

/**
 * TODO: waiting for api response to indicate a user's account was hard cancelled and they can not login.
 *
 */
export default createGoogleTagManagerEvents({
  [logInFailure]: (action, prevState, nextState) => {
    return {
      event: 'trackEvent',
      eventCategory: 'failed login',
      eventAction: 'sign in',
      eventLabel: 'unsuccessful',
    };
  },
  [trackErrorPageRendered]: (action) => {
    const { statusCode, url } = action;

    let eventAction = '';
    switch (statusCode) {
      case 404:
        eventAction = 'PageNotFound';
        break;
      default:
        eventAction = 'PageError';
        break;
    }

    return {
      event: 'pageError',
      eventAction: eventAction,
      eventCategory: 'Error',
      eventLabel: url ?? '',
    };
  },
});
